import { lazy } from "react";

export const PageCMSLoaderImport = async (): Promise<
  typeof import("./PageCMSLoader.component")
> =>
  import(
    /* webpackChunkName: "PageCMSLoader" */
    "./PageCMSLoader.component"
  );

export default lazy(PageCMSLoaderImport);
